import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	requestAccessButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	requestAccessAltText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	heading: {
		id: 'project-directories.components.common.request-access.heading',
		defaultMessage: 'You don’t have access to Compass components',
		description: 'Heading text displayed when the user does not have access to Compass components',
	},
	description: {
		id: 'project-directories.components.common.request-access.description',
		defaultMessage:
			'Ask your admin to give you access to Compass, so you can track the work your team is doing on components of your software architecture.',
		description:
			'Description text displayed when the user does not have access to Compass components',
	},
	requestAccessButtonText: {
		id: 'project-directories.components.common.request-access.button-text',
		defaultMessage: 'Request access',
		description: 'Request access button text',
	},
	requestAccessAltText: {
		id: 'project-directories.components.common.request-access.image-alt-text',
		defaultMessage: 'Request access to Compass',
		description: 'Request access image alt text',
	},
});
export default messages;
